import React from 'react';
import PropTypes from 'prop-types';
import { emptyString } from 'constants/emptyConst';
import { Dialog, Button } from '@totalsoft/rocket-ui';
import { withTranslation } from 'react-i18next';

const DocumentVerificationSummaryModal = ({ closeVerificationSummaryModal, t, summary }) => {
  return (
    <Dialog
      open={true}
      aria-labelledby='externalSearch-dialog-title'
      maxWidth={'sm'}
      disableEscapeKeyDown
      title={t('Summary')}
      id={'documentVerification_summaryModal'}
      content={<div dangerouslySetInnerHTML={{ __html: summary }} />}
      onClose={closeVerificationSummaryModal}
      actions={
        <Button id={'documentVerification_summaryModal_close'} variant='outlined' onClick={closeVerificationSummaryModal} fullWidth>
          {t('Close')}
        </Button>
      }
    />
  );
};

DocumentVerificationSummaryModal.propTypes = {
  closeVerificationSummaryModal: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  summary: PropTypes.string.isRequired
};

DocumentVerificationSummaryModal.defaultProps = {
  summary: emptyString
};

export default withTranslation()(DocumentVerificationSummaryModal);
